import { useMemo } from "react";
import { CompanySearchResult } from "../../../../search/types";
import { useSelector } from "react-redux";
import { organisationsSelector } from "../../../../../redux/organisations/selectors/organisation.selectors";

export const useSelectedCompanyData = (selectedCompany?: CompanySearchResult) => {
  const organisationId = selectedCompany?.organisation.participatingOrganisationId;
  const organisations = useSelector(organisationsSelector);

  const selectedCompanyAccess = useMemo(() => {
    return organisations.find(org => org.id === organisationId);
  }, [organisations, organisationId]);

  const { participatingOrganisationId, exhibitorType } = useMemo(() => {
    if (!selectedCompany) {
      return {
        participatingOrganisationId: undefined,
        exhibitorType: undefined
      };
    }
    const organisation = organisations.find(
      org => org.id === organisationId || org.companyName === selectedCompany.organisation.displayName
    );

    return {
      participatingOrganisationId: organisation?.id,
      exhibitorType: organisation?.exhibitorType
    };
  }, [organisations, selectedCompany, organisationId]);

  return {
    organisationId,
    selectedCompanyAccess,
    participatingOrganisationId,
    exhibitorType
  };
};
